import { useEffect } from "react";
import * as actions from "../redux/FishingAction";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { GameCategoryConst } from "../../../constants/GameCategory";
import { useState } from "react";
import {
  CheckIsNull,
  ResolveArrayNull,
  toAbsoluteUrl,
} from "../../../utils/CommonHelper";
import { GameListing } from "../../common/components/GameListing";
import { useNavigate, useLocation } from "react-router-dom";
import { GameTypeEnum } from "../../../enumeration/GameTypeEnum";
import { useRef } from "react";

export const FishingListing = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [category, setCategory] = useState(GameCategoryConst.ALL);
  const location = useLocation();
  const [companyCode, setCompanyCode] = useState(
    location.state ? location.state.companyCode : undefined
  );
  const [companyOffset, setCompanyOffset] = useState(
    location.state ? parseInt(location.state.companyOffset) : 0
  );
  const isInitial = useRef(true);
  const navigate = useNavigate();

  const fishingState = useSelector(({ fishing }) => fishing, shallowEqual);

  useEffect(() => {
    document.body.classList.add("pages-bg", "h-100", "scroll-y-default");
    document.querySelector("html").classList.add("h-100", "scroll-y-default");

    document.body.style.backgroundImage = `url("${toAbsoluteUrl(
      "images/pagesBg/fishing.png"
    )}")`;

    dispatch(actions.getFishingPageUI());

    return () => {
      document.body.classList.remove("pages-bg", "h-100", "scroll-y-default");
      document.body.style.backgroundImage = ``;
      document
        .querySelector("html")
        .classList.remove("h-100", "scroll-y-default");
      dispatch(actions.clearFishingGameList());
    };
  }, []);

  useEffect(() => {
    if (fishingState.fishingPageUI) {
      const company = companyCode
        ? companyCode
        : fishingState.fishingPageUI.companyLists[0].companycode;

      if (!companyCode) {
        setCompanyCode(company);
      }

      const params = {
        companycode: company,
        language: intl.locale,
        category,
      };
      dispatch(actions.getFishingGameList(params)).then(() => {
        if (location.state && isInitial.current) {
          document.body.scrollTo({
            top: parseInt(location.state.scrollPosition),
            behavior: "smooth",
          });
        }
        isInitial.current = false;
      });
    }
  }, [fishingState.fishingPageUI, companyCode, category]);

  const handlePlayGame = (gameCode, searchName) => {
    navigate(
      `/gamePlay/${companyCode}/${gameCode}/${companyOffset}/${
        document.body.scrollTop
      }/${GameTypeEnum.FISHING}${
        CheckIsNull(searchName) ? "" : `/${searchName}`
      }`
    );
  };

  return (
    <>
      <GameListing
        pageUI={fishingState.fishingPageUI}
        gameList={fishingState.fishingGameList?.fishingGameLists}
        gameCategoryList={fishingState.fishingGameList?.fishingGameLists}
        setCategory={setCategory}
        category={category}
        companyCode={companyCode}
        setCompanyCode={setCompanyCode}
        handlePlayGame={handlePlayGame}
        setCompanyOffset={setCompanyOffset}
        companyOffset={companyOffset}
        initialSearchName={location.state ? location.state.searchName : ""}
        isShowBtn={
          ResolveArrayNull(fishingState.fishingPageUI?.companyLists).length > 6
        }
      />
    </>
  );
};
